import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./pages/users-page/users-page.module').then((m) => m.UsersPageModule),
    },
    {
        path: ':id',
        loadChildren: () => import('./pages/view-users-page/view-users-page.module').then((m) => m.ViewUsersPageModule),
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class UsersRoutingModule { }
